module.exports = __webpack_public_path__ + "static/media/21_B.d0630b7f.png";